import { Link } from '@digital-pulse/react';
import {
  EXTERNAL_IDENTITY_INFO_ROUTE,
  PERSONAL_INFO_ROUTE,
  PRESCRIPTION_LABEL_ROUTE,
  SIGN_IN_ROUTE
} from '@/lib/constants/routes';
import { withPrefix } from '../../helpers/helpers';
import CustomerCare from '../customerCare/customerCare';
import { CONS } from '@/lib/constants/phoneDob';
import { isCaremark, isSpecialty } from '@/lib/utils/utils';
import { clickAnalytics, tags } from '@/lib/utils/analytics';

export const twoLookupAttemptsLeft = (isPet = false, translations?: any, showLink = true) => {
  const TWO_ATTEMPTS_DESC = translations?.TWO_ATTEMPTS_REMAINING_DESC;
  const TWO_ATTEMPTS_PET_DESC = translations?.TWO_ATTEMPTS_REMAINING_PET_DESC;
  const TRY_PERSONAL_INFO = translations?.ERROR_LINK_TEXT?.TRY_PERSONAL_INFO;
  const TRY_PRESCRIPTION_LABEL = translations?.ERROR_LINK_TEXT?.TRY_PRESCRIPTION_LABEL;
  const ENTER_PRESCRIPTION_AGAIN = translations?.ERROR_LINK_TEXT?.ENTER_PRESCRIPTION_AGAIN;
  const ENTER_PERSONAL_INFO_AGAIN = translations?.ERROR_LINK_TEXT?.ENTER_PERSONAL_INFO_AGAIN;

  if (window.location.href.indexOf(PRESCRIPTION_LABEL_ROUTE) > -1) {
    return (
      <>
        {isPet ? TWO_ATTEMPTS_PET_DESC : TWO_ATTEMPTS_DESC}
        {showLink && (
          <>
            <br />
            <br />
            <Link href={withPrefix(PERSONAL_INFO_ROUTE)}>{TRY_PERSONAL_INFO}</Link>,{' '}
            {ENTER_PRESCRIPTION_AGAIN}.
          </>
        )}
      </>
    );
  }
  if (window.location.href.indexOf(PERSONAL_INFO_ROUTE) > -1) {
    return (
      <>
        {isPet ? TWO_ATTEMPTS_PET_DESC : TWO_ATTEMPTS_DESC}
        <br />
        <br />
        <Link href={withPrefix(PRESCRIPTION_LABEL_ROUTE)}>{TRY_PRESCRIPTION_LABEL}</Link>,{' '}
        {ENTER_PERSONAL_INFO_AGAIN}.
      </>
    );
  }
  return '';
};

export const noMatchFoundError = (translations?: any) => {
  const ERRORS = translations?.UNIFIED_REGISTRATION_ERRORS;
  return (
    <>
      {ERRORS?.NO_MATCH_FOUND_DESCRIPTION} <CustomerCare />.
    </>
  );
};

export const accountLockedError = (translations?: any) => {
  const ERRORS = translations?.UNIFIED_REGISTRATION_ERRORS;
  return (
    <>
      {ERRORS?.ACCOUNT_LOCKED_DESCRIPTION} <CustomerCare />.
    </>
  );
};

export const errorDescription = (errDesc: string) => {
  return <div dangerouslySetInnerHTML={{ __html: errDesc }} />;
};

export const phoneDOBErrorRemainingAttempts = (
  errDesc: string,
  lookupData: any,
  updateLookupData: any,
  translations?: any
) => {
  const phoneDobCons = translations?.LOOKUP_ERRORS;
  const link = lookupData?.phoneDOBInfoFormFlag
    ? phoneDobCons.swap_forms.link_to_rx_label
    : phoneDobCons.swap_forms.link_to_phone_dob;
  const tryAgain = lookupData?.phoneDOBInfoFormFlag
    ? phoneDobCons.swap_forms.try_again_phone_dob
    : phoneDobCons.swap_forms.try_again_rx_label;
  const switchForms = () => {
    updateLookupData({ phoneDOBInfoFormFlag: !lookupData?.phoneDOBInfoFormFlag });
    clickAnalytics({
      payload: {
        link_name: `${tags.account}:${tags.selfServe}:${tags.phoneDOB}:${
          lookupData?.phoneDOBInfoFormFlag ? tags.usePersonalInfo : tags.useRxLabel
        }`
      }
    });
  };
  return (
    <>
      {errDesc}
      <Link href={'javascript:;'} variant="inline" onClick={() => switchForms()}>
        {link}
      </Link>{' '}
      {tryAgain}
    </>
  );
};

export const phoneDOBErrorDesc = (errDesc: string, translations?: any) => {
  const phoneDobCons = translations?.CONS || CONS;

  return (
    <>
      <p>{errDesc}</p>
      <Link
        href={
          SIGN_IN_ROUTE +
          `${
            !isSpecialty() && !isCaremark()
              ? '?returnUrl=' + encodeURI('/account/onboarding/landing?source=PHARMACY')
              : ''
          }`
        }
        variant="standalone"
      >
        {phoneDobCons.sign_in}
      </Link>
    </>
  );
};

export const customerCareLockedError = (translations?: any) => {
  const ERRORS = translations?.UNLOCK_USER_ERRORS;
  return (
    <>
      {ERRORS?.CUSTOMER_CARE_LOCK_DESCRIPTION} <CustomerCare />.
    </>
  );
};

export const unlockUserLookupLockedError = (translations?: any) => {
  const ERRORS = translations?.UNLOCK_USER_ERRORS;
  return (
    <>
      {ERRORS?.LOOKUP_LOCKED_DESCRIPTION} <CustomerCare />.
    </>
  );
};

export const notRegisteredError = (translations?: any) => {
  const ERRORS = translations?.FORGOT_USERNAME_ERRORS;
  const { DESCRIPTION, CTA } = isCaremark()
    ? ERRORS?.NOT_REGISTERED_CAREMARK
    : ERRORS?.NOT_REGISTERED_SPECIALTY;
  return (
    <>
      <p>{DESCRIPTION}</p>
      <Link href={'/account-login/look-up?flow=classic'} variant="inline">
        {CTA}
      </Link>
    </>
  );
};
